import React, { useState, useEffect } from "react";

const TaskCompletionModal = ({
  show,
  onClose,
  onSuccess,
  facilityId,
  childTask,
  staffUsers,
  onSubmit,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    date: "",
    staffId: "",
    notes: "",
    status: "completed",
    timeSpent: "",
    quality: "good",
  });

  useEffect(() => {
    if (childTask) {
      const selectedDate = childTask.selectedDate || new Date();
      setFormData({
        date: selectedDate.toISOString().split("T")[0],
        staffId: "",
        notes: "",
        status: "completed",
        timeSpent: "",
        quality: "good",
      });
    }
  }, [childTask]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onSubmit(formData);
      onSuccess();
    } catch (error) {
      console.error("Error submitting task completion:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!show || !childTask) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Mark Task Completion</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Task</label>
                <div className="card bg-light">
                  <div className="card-body p-2">
                    <h6 className="mb-1">{childTask.name}</h6>
                    <small className="text-muted">
                      {childTask.description}
                    </small>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Completion Date *</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={formData.date}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Completed By *</label>
                    <select
                      className="form-select"
                      name="staffId"
                      value={formData.staffId}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Staff Member</option>
                      {staffUsers.map((user) => (
                        <option key={user._id} value={user._id}>
                          {user.fullName || user.name} - {user.role}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                    >
                      <option value="completed">Completed</option>
                      <option value="partially_completed">
                        Partially Completed
                      </option>
                      <option value="not_applicable">Not Applicable</option>
                      <option value="skipped">Skipped</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Time Spent (minutes)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="timeSpent"
                      value={formData.timeSpent}
                      onChange={handleInputChange}
                      placeholder="e.g., 30"
                      min="0"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Quality of Work</label>
                    <select
                      className="form-select"
                      name="quality"
                      value={formData.quality}
                      onChange={handleInputChange}
                    >
                      <option value="excellent">Excellent</option>
                      <option value="good">Good</option>
                      <option value="satisfactory">Satisfactory</option>
                      <option value="needs_improvement">
                        Needs Improvement
                      </option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Notes</label>
                    <textarea
                      className="form-control"
                      name="notes"
                      rows="3"
                      value={formData.notes}
                      onChange={handleInputChange}
                      placeholder="Add any notes about the task completion..."
                    />
                  </div>
                </div>
              </div>

              <div className="alert alert-info">
                <small>
                  <i className="ti ti-info-circle me-1"></i>
                  This will record that the task "{childTask.name}" was
                  completed on the selected date by the specified staff member.
                </small>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !formData.staffId}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                Record Completion
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TaskCompletionModal;
